/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown> }} Notes_V2_Page_AnchorInputs */

const en_notes_v2_page_anchor = /** @type {(inputs: Notes_V2_Page_AnchorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page}`)
};

const es_notes_v2_page_anchor = /** @type {(inputs: Notes_V2_Page_AnchorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page}`)
};

/**
* | output |
* | --- |
* | "Page {page}" |
*
* @param {Notes_V2_Page_AnchorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_page_anchor = /** @type {((inputs: Notes_V2_Page_AnchorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Page_AnchorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_page_anchor(inputs)
	return en_notes_v2_page_anchor(inputs)
});